<template>
  <div class="col-lg-12" style="padding: 20px 30px">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">
          2023 Winter Camp 신청목록
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            2023 Winter Camp → 신청목록
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #actions>
            <Create-Event ref="newSub" #default="m"> </Create-Event>
          </template>
          <template #resultactions="props"
            ><!--추후 제공예정-->

            <div style="text-align: right">
              <template v-if="this.$root.guiPerm === 'ROOT'">
                <Create-Event ref="newSub" #default="m">
                  <button class="btn btn-danger" @click="m.click()">
                    2023 Winter Camp 신청하기
                  </button>
                </Create-Event>
              </template>

              <!--button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()">2023 Winter Camp 신청하기</button-->
              <router-link to="/events/2023_Winter_learningreview"
                ><button class="btn btn-secondary">
                  학습후기
                </button></router-link
              >
              <router-link to="/events/2023_Winter_view"
                ><button class="btn btn-success">학습현황</button></router-link
              >
            </div>
          </template>

          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id"
              :class="{ 'table-danger': record.is_deleted }"
            >
              <td scope="col">
                <input type="checkbox" v-model="record.checked" />
              </td>
              <td scope="row" style="text-align: center">{{ record.id }}</td>

              <td style="text-align: center">
                <!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a-->
                {{ record.username }}
              </td>

              <td style="text-align: center">
                <Student :student="record" />
              </td>
              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                <Business v-if="record.t2" :biz="record.t2" />
              </td>

              <td style="text-align: center">
                <Business v-if="record.t1" :biz="record.t1" />
              </td>
              <td style="text-align: center">{{ record.tutor_name }}</td>
              <td style="text-align: center">
                <span v-if="record.type === 'MYPATH'">MY PATH</span>
                <span v-if="record.type === 'ChildU'">ChildU</span>
              </td>
              <td style="text-align: center">{{ record.level }}</td>
              <td style="text-align: center">
                <span v-if="record.startDate">{{
                  record.startDate.substr(2, 8)
                }}</span>
              </td>
              <td style="text-align: center">
                <span v-if="record.endDate">{{
                  record.endDate.substr(2, 8)
                }}</span>
              </td>
              <td style="text-align: center">
                <span
                  v-if="record.endDate"
                  :style="{ color: getDiff(record.endDate) <= 0 ? 'red' : '' }"
                  >{{ getDiff(record.endDate) + " 일" }}</span
                >
              </td>

              <td style="text-align: center">
                <span
                  v-if="!record.active_subscription_id"
                  style="
                    background: #ff0000;
                    color: #fff;
                    padding: 2px 6px;
                    font-size: 12px;
                  "
                  >미사용</span
                ><template v-else
                  ><span
                    v-if="record.ranking_exception"
                    style="
                      background: #ffcc00;
                      color: #333;
                      padding: 2px 6px;
                      font-size: 12px;
                    "
                    >이벤트</span
                  ><span
                    v-else
                    style="
                      background: #0071e3;
                      color: #fff;
                      padding: 2px 6px;
                      font-size: 12px;
                    "
                    >정회원</span
                  ></template
                >
              </td>
              <td>
                <span
                  v-if="
                    (record.type === 'MYPATH' || record.id === '71710') &&
                    this.$root.guiPerm == 'ROOT'
                  "
                >
                  <button
                    type="button"
                    @click="
                      getCurrent(
                        true,
                        record.id,
                        record.username,
                        record.name,
                        record.t1.name,
                        record.t2.name
                      )
                    "
                    class="btn btn-success btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    학습입력
                  </button></span
                >

                <!-- Modal -->
                <div
                  class="modal fade"
                  id="exampleModal"
                  tabindex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                          Mypath 학습데이터 입력
                        </h5>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <table class="table">
                          <tr>
                            <th>학원</th>
                            <td>{{ selData.Business }}</td>
                          </tr>
                          <tr>
                            <th>클래스</th>
                            <td>{{ selData.activeBusiness }}</td>
                          </tr>
                          <tr>
                            <th>이름</th>
                            <td>{{ selData.hanName }}</td>
                          </tr>
                          <tr>
                            <th>아이디</th>
                            <td>{{ selData.username }}</td>
                          </tr>
                          <tr>
                            <th>학습일자</th>
                            <td><input type="date" v-model="hSetDate" /></td>
                          </tr>
                          <tr>
                            <th>학습시간</th>
                            <td>
                              <input
                                type="text"
                                placeholder="초 단위로 입력"
                                style="text-align: center; width: 120px"
                                v-model="DateDi"
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addHistory()"
                        >
                          Save changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </query-grid>

        <div
          class="modal fade bd-example-modal-lg"
          tabindex="-1"
          role="dialog"
          id="studentModal"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5
                  class="modal-title"
                  id="exampleModalLongTitle"
                  v-if="creating"
                >
                  2023 Winter Camp 신청하기
                </h5>
              </div>
              여기는 해당학원에 전체 리스트가 뿌려지게 처리(각자 권한에 맞는
              리스트가 보이게)
              <div class="modal-body" v-if="selData.deleted">
                학생이 삭제되어 더 이상 할 수 있는 작업이 없습니다. 이 창을
                닫으세요.
              </div>
              <div class="modal-body" v-else>
                <div>
                  <p class="title" style="font-size: 16px" v-if="!creating">
                    {{ selData.hanName }}({{ selData.username }}) 회원
                  </p>
                  <div
                    style="
                      display: inline-block;
                      padding: 10px 0 20px;
                      float: right;
                      margin-right: 30px;
                    "
                  >
                    <!--button type="button" class="btn btn-primary" style="font-size: 14px!important;"
                      v-if="!creating">학습부여</button-->
                  </div>

                  <div
                    class="card-header"
                    style="clear: both; background: #fff"
                  ></div>
                  <div class="card-body">
                    <table class="table">
                      <thead>
                        <tr>
                          <td>check</td>
                          <td>회원번호</td>
                          <td>학원</td>
                          <td>클래스</td>
                          <td>아이디</td>
                          <td>이름</td>
                          <td>유형</td>
                          <td>레벨</td>
                          <td>시작일</td>
                          <td>종료일</td>
                          <td>잔여일</td>
                          <td>상태</td>
                          <td>비고</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><input type="checkbox" /></td>
                          <td>회원번호</td>
                          <td>학원</td>
                          <td>클래스</td>
                          <td>아이디</td>
                          <td>이름</td>
                          <td>유형</td>
                          <td>레벨</td>
                          <td>시작일</td>
                          <td>종료일</td>
                          <td>잔여일</td>
                          <td>상태</td>
                          <td>비고</td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="flex_center">
                      <button class="btn btn-danger" style="">신청하기</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['CLASS']"
    render-button
    :callback="selectedBiz"
    :selectedNode="{ id: selData.activeBusiness }"
    ref="biz"
  />
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import Business from "../components/Business";
import LevelMultiple from "../components/LevelMultiple";
import Student from "../components/detail_pages/Student";
import IMS from "../components/IMS";
import QueryGrid from "../components/QueryGrid";
import axios from "axios";
import VueCookies from "vue-cookies";
import CreateEvent from "../components/detail_pages/Event.vue";
export default {
  name: "Home",
  components: {
    LevelMultiple,
    Tree,
    treeBtn,
    Business,
    Student,
    IMS,
    CreateEvent,
    QueryGrid,
  },
  mounted() {
    if (this.$route.query.type) {
      /*this.typeFilter = {};
        this.typeFilter[this.$route.query.type] = true;*/
      this.$refs.qg.pushSetting(
        "status_filter_" + this.$route.query.type,
        true
      );
    }

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.$refs.qg.pushSetting("status_filter_ACTIVE", true);
      this.config.columns.splice(4, 1);
    }

    this.$refs.qg.search();

    this.$watch(
      () => this.$route.query.type,
      function (toQuery, previousQuery) {
        // react to route changes...

        this.$refs.qg.pushSetting("status_filter_ACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_INACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_EVENT", false);
        if (toQuery)
          this.$refs.qg.pushSetting("status_filter_" + toQuery, true);

        this.$refs.qg.search();
      }
    );
  },
  methods: {
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }
    },
    selectedBiz(biz) {
      this.selBiz = biz;
      this.changedData.activeBusiness = biz.id;
    },
    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      var data = {};
      if (this.creating) {
        data = {
          ...this.selData,
          ...this.changedData,
          activeBusiness: this.selBiz.id,
          product: this.selProduct.id,
          paymentMethod: this.selData.payMethod,
          hopeStart: this.selData.hopeStart,
          level: this.selData.level,
        };
      } else {
        data = this.changedData;
      }
      axios({
        method: this.creating ? "post" : "patch",
        url: "/students" + (!this.creating ? "/" + this.selData.id : ""),
        data: data,
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.$refs.qg.search();
          $.notify(
            {
              // options
              message: "학생 생성이 처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          bootstrap.Modal.getInstance(
            document.getElementById("studentModal")
          ).hide();
          if (this.selData.addSubscription) {
            $.notify(
              {
                // options
                message: "아이디 생성을 처리중입니다",
              },
              {
                // settings
                type: "info",
                z_index: 9999,
              }
            );

            axios
              .post("/subscriptions", {
                student: response.data.id,
                product: this.selProduct.id,
                paymentMethod: this.selData.payMethod,
                hopeStart: this.selData.hopeStart,
                level: this.selData.level,
              })
              .then((response) => {
                if (response.data.error) {
                  $.notify(
                    {
                      // options
                      message: "ID 추가 실패: " + response.data.error,
                    },
                    {
                      // settings
                      type: "danger",
                      z_index: 9999,
                    }
                  );
                } else {
                  if (
                    confirm(
                      "아이디까지 같이 신청이 완료되었습니다. 결제창으로 이동할까요?"
                    )
                  ) {
                    this.$router.push("/subscriptions?id=" + response.data.id);
                  } else {
                    this.$refs.qg.search();
                    $.notify(
                      {
                        // options
                        message: "아이디 신청되었습니다.",
                      },
                      {
                        // settings
                        type: "success",
                        z_index: 9999,
                      }
                    );
                  }
                }
              });
          }
        }
      });
    },
    fetchProducts(source) {
      var extras = "?";
      if (source) {
        extras += "source=" + source.id;
      }
      axios.get("/products" + extras).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.products = response.data.result;
        }
      });
    },

    fetchSubscriptions(student) {
      var extras = "";
      //this.levelRequest.record = {};
      axios
        .get('/subscriptions?status_filter=["ACTIVE"]&student=' + student.id)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            student.subscriptions = response.data.result.filter(
              (x) => x.product == "ChildU"
            );
          }
        });
    },
    addHistory() {
      var data = {
        h_date: this.hSetDate,
        DateDi: this.DateDi,
        intMemberID: this.selData.id,
      };
      var send = axios({
        method: "post",
        url: "/studies/historysave",
        data: data,
      });

      console.log(this.hSetDate);

      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );

          this.$router.push(
            this.creating
              ? response.data.id.toString()
              : "../" + response.data.id.toString()
          );
        }
      });
    },
    fetchSubscriptionsChecked() {
      this.$refs.qg.checked.forEach((s) => {
        this.fetchSubscriptions(s);
      });
    },
    getDiff(value) {
      var moment = require("moment"); // moment 모듈불러오기

      const diff = moment().diff(value, "hours");
      const days = Math.floor(diff / 24);
      const hours = diff % 24;

      return -days;
    },
    getCurrent(reset, intMemberID, username, hanName, s_name, n_name) {
      //if(reset){
      this.selData = {
        id: intMemberID,
        username: username,
        hanName: hanName,
        activeBusiness: s_name,
        Business: n_name,
      };
      //console.log(this.selData)
      //}
    },
    creatingMode() {
      this.selData = {
        id: "",
        activeBusiness: "",
        username: "",
        hanName: "",
      };
      this.creating = true;
      this.changedData = {};
    },
    nvl(str) {
      if (typeof str == "undefined" || str == null) str = defaultStr;
      return str;
    },
  },
  filters: {
    currency(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      config: {
        name: "학생 리스트",
        req_endpoint: "/students/eventList/4",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },

          {
            id: "prod_filter",
            name: "상품유형",
            type: "switch",
            filter_type: {
              ChildU: "ChildU",
              MYPATH: "MyPath",
              ALL: "ChildU + MyPath",
            },
          },

          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder:
              "아이디/이름/회원번호/튜터명/학원/클래스/담당교사/레벨",
          },
          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              start_date: "시작일",
              end_date: "종료일",
            },
          },
          {
            id: "trophy",
            name: "결과검색",
            type: "switch",
            value_name: "잔여일",
            filter_type: {
              "1st": "대상",
              "2nd": "최우수상",
              "3rd": "우수상",
            },
          },
        ],
        columns: [
          {
            id: "chkbox",
            name: "체크",
            is_check: true,
          },
          {
            id: "id",
            sortable: true,
            name: "회원번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanname",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "biz",
            sortable: true,
            name: "학원",
            excel_print: (v) => {
              return v.t2.name;
            },
          },
          {
            id: "class",
            sortable: true,
            name: "클래스/캠퍼스",
            excel_print: (v) => {
              return v.t1.name;
            },
          },
          {
            id: "tutor_name",
            sortable: true,
            name: "담당교사",
            excel_print: (v) => {
              return v.tutor_name;
            },
          },
          {
            id: "type",
            sortable: true,
            name: "학습유형",
            excel_print: (v) => {
              return v.type || "";
            },
          },
          {
            id: "level",
            sortable: true,
            name: "레벨",
            excel_print: (v) => {
              return v.level || "";
            },
          },
          {
            id: "start_date",
            sortable: true,
            name: "시작일",
            excel_print: (v) => {
              return v.startDate || "";
            },
          },
          {
            id: "end_date",
            sortable: true,
            name: "종료일",
            excel_print: (v) => {
              return v.endDate || "";
            },
          },
          {
            id: "remain_days",
            sortable: true,
            name: "잔여일",
            excel_print: (v) => {
              return this.getDiff(v.endDate) || "";
            },
          },
          {
            id: "status",
            name: "상태",
            sortable: true,
            excel_print: (v) => {
              return v.active_subscription_id
                ? v.ranking_exception
                  ? "이벤트"
                  : "정회원"
                : "미사용";
            },
          },
          {
            id: "ttt",
            name: "비고",
            sortable: true,
            excel_print: (v) => {
              return v.active_subscription_id
                ? v.ranking_exception
                  ? "이벤트"
                  : "정회원"
                : "미사용";
            },
          },
        ],
        disable_init_search: true,
      },
      selBiz: {
        name: "",
      },
      subscriptions: [],
      selData: {
        id: "",
        activeBusiness: "",
        username: "",
        hanName: "",
        Business: "",
      },
      changedData: {},
      selProduct: {},
      selectedSubscription: {
        id: 0,
      },
      products: [],
      creating: true,
    };
  },
};
</script>
